<template>
    <BreadCrumb PageTitle="Ajouter une promotion" />
    <AddPromotion />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
    import AddPromotion from "../../../components/Ecommerce/Promotion/AddPromotion.vue";
  
    export default defineComponent({
      name: "AddPromotionPage",
      components: {
        BreadCrumb,
        AddPromotion,
      },
    });
  </script>